<template>
  <v-container>
    <v-layout row wrap>
      <v-flex xs12 class="pb-2">
        <h3>人気のタグ</h3>
      </v-flex>
      <v-flex xs12>
        <tag-bar :tags="tags" />
      </v-flex>
      <v-flex xs12>
        <error-message ref="errorDialog" />
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import TagBar from "@/components/TagBar.vue";
import ErrorMessage from "@/components/parts/ApiErrorMessage.vue";

export default {
  components: {
    TagBar,
    ErrorMessage
  },
  data() {
    return {
      tags: []
    };
  },
  created() {
    this.$http
      .get("/v1/tags/top10")
      .then(res => {
        for (const key in res.data) {
          this.tags.push(res.data[key].tag_name);
        }
      })
      .catch(error => {
        this.$refs.errorDialog.setMessage(
          "人気タグの取得に失敗しました。詳細：[" +
            error.response.status +
            "] " +
            error.response.statusText
        );
      });
  }
};
</script>
